import Vue from "vue";
import vSelect from "vue-select";

Vue.component("v-select", vSelect);

document.addEventListener('DOMContentLoaded',function() {

    if(!document.getElementById('app-search'))
        return;

    const app = new Vue({
        el: '#app-search',
        data: {
            translations: JSON.parse(document.getElementById('app-search').dataset.translations),
            offers: [],

            categories: [],
            category: null,
            business_units: [],
            business_unit: null,

            locations: [],
            location: null,
            names: [],
            cafe_name: null,
            professions: [],
            profession: null,
            endpointUrl: document.getElementById('app-search').dataset.url,
            // endpointUrl: '/sample.json',
            // endpointUrl: 'http://localhost:9994/sample.json',

            showPagination: false,
            canRefresh: false,
            totalOffers: 0,

            // pagination vars
            currentPage: 1,
            totalPages: 1,
            perPage: 15,
            indexOfLastOffer: 1,
            indexOfFirstOffer: 1,
            currentOffers: [],
            showPages: [],
            showLoading: true,
        },
        created() {
            document.getElementById('app-search').style.visibility = 'visible';
        },
        mounted() {
            this.getOffers();
        },
        computed: {
            filteredOffers: function() {
                let offers = this.offers;
                if(this.canRefresh) {
                    if (this.location && this.location !== this.translations.all  ) {
                        offers = offers.filter(offer => offer.location === this.location);
                    }
                    if (this.cafe_name && this.cafe_name !== this.translations.all  ) {
                        offers = offers.filter(offer => offer.cafe_name === this.cafe_name);
                    }
                    if (this.profession && this.profession !== this.translations.all) {
                        offers = offers.filter(offer => offer.profession === this.profession);
                    }

                    if (this.category && this.category !== this.translations.all) {
                        offers = offers.filter(offer => offer.category === this.category);
                    }
                    if (this.business_unit && this.business_unit !== this.translations.all) {
                        offers = offers.filter(offer => offer.business_unit === this.business_unit);
                    }

                }
                return offers;
            }
        },
        methods: {
            openmodal: function(id) {
                $('#job-offer-modal-'+id).modal('show');
                const images = document.querySelectorAll('#job-offer-modal-'+id+' img[data-src]');
                if(images.length) {
                    images.forEach(image => {
                        image.src = image.dataset.src;
                        image.removeAttribute('data-src');
                    });
                }
            },
            search: function() {
                this.currentPage = 1;
                this.canRefresh = true;
                this.reloadPagination();
                this.canRefresh = false;
            },
            getOffers: function() {

                this.request(this.endpointUrl, data => {
                    this.showLoading = false;
                    this.currentPage = 1;
                    this.setCurrentPage(this.currentPage);

                    this.offers = data;

                    this.reloadPagination();


                    this.locations = [...new Set(this.offers.map(item => item.location))];
                    this.professions = [...new Set(this.offers.map(item => item.profession))];
                    this.names = [...new Set(this.offers.map(item => item.cafe_name))];

                    this.categories = [...new Set(this.offers.map(item => item.category))];
                    this.business_units = [...new Set(this.offers.map(item => item.business_unit))];

                    this.locations.sort();
                    this.professions.sort();
                    this.names.sort();

                    this.categories.sort();
                    this.business_units.sort();

                    this.locations.unshift(this.translations.all);
                    this.professions.unshift(this.translations.all);
                    this.names.unshift(this.translations.all);

                    this.categories.unshift(this.translations.all);
                    this.business_units.unshift(this.translations.all);

                });

            },
            reloadPagination: function() {
                this.totalPages = Math.ceil(this.filteredOffers.length / this.perPage);
                this.indexOfLastOffer = this.currentPage * this.perPage;
                this.indexOfFirstOffer = this.indexOfLastOffer - this.perPage;
                this.currentOffers = this.filteredOffers.slice(this.indexOfFirstOffer, this.indexOfLastOffer);

                if (this.totalPages < 4) {
                    this.showPages = this.range(1, this.totalPages);
                } else if (this.currentPage - 1 > 0 && this.currentPage + 1 < this.totalPages) {
                    this.showPages = this.range(this.currentPage - 1, this.currentPage + 1);
                } else if (this.currentPage - 1 < 1) {
                    this.showPages = this.range(1, 3);
                } else {
                    this.showPages = this.range(this.totalPages - 2, this.totalPages);
                }

                this.showPagination = this.filteredOffers.length > this.perPage;
                this.totalOffers = this.filteredOffers.length;
            },
            range: function (from, to) {
                let arr = [];
                for(let i = from; i <= to; ++i) {
                    arr.push(i);
                }
                return arr;
            },
            setCurrentPage: function(page) {
                this.currentPage = page;
                this.reloadPagination();
            },
            setPage: function(page) {
                this.setCurrentPage(page);
                this.scrollUp();
            },
            nextPage: function() {
                if(this.currentPage < this.totalPages) {
                    this.setCurrentPage(this.currentPage + 1);
                    this.scrollUp();
                }
            },
            prevPage: function() {
                if(this.currentPage > 1) {
                    this.setCurrentPage(this.currentPage - 1);
                    this.scrollUp();
                }
            },
            scrollUp: function() {

                if(document.querySelector('#top-offer')) {
                    setTimeout(function() {
                        const targetElement = document.querySelector('#top-offer');
                        targetElement.scrollIntoView();
                    },0 );
                }
            },
            goTo: function (url){
                window.open(url,'_self');
            },
            request: function (url, callback) {
                const request = new XMLHttpRequest();
                // var that = this;
                // that.showPreloader();
                // that.hideList();
                request.onreadystatechange = function() {
                    if(request.readyState === 4 && request.status === 200) {
                        // that.hidePreloader();
                    } else {
                        // that.showPreloader();
                    }
                }

                request.open('GET', url, true);

                request.onload = function() {
                    if (this.status >= 200 && this.status < 400) {
                        callback(JSON.parse(this.response))
                    }
                };
                request.send();
            },
        }
    });

});
